import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, ArrowRight } from 'lucide-react';
import { schoolsAPI } from '@/lib/api';

const SchoolsPage = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await schoolsAPI.getAll();
        setSchools(response.data);
      } catch (error) {
        console.error('Failed to fetch schools:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSchools();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[#D4AF37]">در حال بارگذاری...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl sm:text-6xl font-light text-white mb-4">
            <span className="text-[#D4AF37]">مدارس</span> معتبر جهان
          </h1>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto">
            بهترین مدارس و موسسات آموزشی برای تحصیل (زیر دیپلم)
          </p>
        </div>

        {/* Schools Grid */}
        {schools.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {schools.map((school) => (
              <Link
                key={school.id}
                to={`/schools/${school.id}`}
                data-testid="school-card"
                className="glass-effect border border-white/10 rounded-2xl overflow-hidden hover:border-[#D4AF37]/30 transition-all group"
              >
                {school.logo_url && (
                  <div className="relative h-48 overflow-hidden bg-white/5 flex items-center justify-center p-8">
                    <img
                      src={school.logo_url}
                      alt={school.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                )}
                
                <div className="p-6">
                  <h3 className="text-xl font-medium text-white mb-2 group-hover:text-[#D4AF37] transition-colors">
                    {school.name}
                  </h3>
                  
                  <div className="flex items-center gap-2 text-sm text-zinc-400 mb-3">
                    <Globe size={16} className="text-[#D4AF37]" />
                    <span>{school.location}</span>
                  </div>
                  
                  <div className="inline-block px-3 py-1 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full text-sm text-[#D4AF37]">
                    {school.type}
                  </div>
                  
                  <div className="flex items-center gap-2 text-[#D4AF37] text-sm font-medium mt-4">
                    مشاهده جزئیات
                    <ArrowRight size={16} className="rotate-180 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center text-zinc-400 py-20">
            <p className="text-xl">مدرسه‌ای یافت نشد.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SchoolsPage;
